<template>
  <section class="vehicle-page-media">
    <div class="vehicle-page-media__container">
      <div class="vehicle-page-media__card">
        <div class="vehicle-page-media__bg">
          <QImg :src="effectivePosterUrl" class="vehicle-page-media__bg-image" no-spinner />
        </div>
        <div class="vehicle-page-media__overlay">
          <div class="vehicle-page-media__title-block">
            <p class="vehicle-page-media__eyebrow">{{ eyebrow }}</p>
            <h2 class="vehicle-page-media__title">{{ title }}</h2>
          </div>
          <button type="button" class="vehicle-page-media__play-btn" aria-label="Play video" @click="$emit('play')">
            <QIcon :name="evaPlayCircleFilled" size="100px" />
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { QImg, QIcon } from 'quasar';
import { evaPlayCircleOutline } from '@quasar/extras/eva-icons';

export default {
  name: 'VehiclePageMedia',
  components: {
    QImg,
    QIcon
  },
  props: {
    eyebrow: {
      type: String,
      default: 'MEDIA'
    },
    title: {
      type: String,
      default: ''
    },
    posterUrl: {
      type: String,
      default: ''
    },
    videoId: {
      type: String,
      default: ''
    }
  },
  computed: {
    effectivePosterUrl() {
      if (this.posterUrl) return this.posterUrl;
      if (this.videoId) {
        return `https://img.youtube.com/vi/${this.videoId}/maxresdefault.jpg`;
      }
      return '';
    }
  },
  created() {
    this.evaPlayCircleFilled = evaPlayCircleOutline;
  }
};
</script>
